import React, { FC } from "react";

import { Sort } from "@/components/atoms/Sorting/useSort";
import { Table } from "@/components/molecules";
import { InsuredGood, InsuredGoodSortProperty } from "@/shared/domain";

import InsuredGoodTableItem from "./InsuredGoodTableItem/InsuredGoodTableItem";
import { insuredGoodTableColumns } from "./utils";

export type InsuredGoodTableProps = {
    insuredGoods: InsuredGood[];
    orderBy: Sort<InsuredGoodSortProperty>;
    handleSort: (orderBy: InsuredGoodSortProperty) => void;
};

const InsuredGoodTable: FC<InsuredGoodTableProps> = ({ insuredGoods, handleSort, orderBy }) => {
    return (
        <Table<InsuredGood, InsuredGoodSortProperty>
            condensed
            columns={insuredGoodTableColumns}
            handleSort={handleSort}
            orderBy={orderBy}
            items={insuredGoods}
            renderItem={(insuredGood) => <InsuredGoodTableItem insuredGood={insuredGood} key={insuredGood.id} />}
        />
    );
};

export default InsuredGoodTable;
